import { render } from "./ProductsByFilters.vue?vue&type=template&id=039ea7da"
import script from "./ProductsByFilters.vue?vue&type=script&lang=js"
export * from "./ProductsByFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__